<template>
  <nav id="main-navbar" class="navbar navbar-expand-lg navbar-dark navbar-bg justify-content-start">
    <a class="btn btn-primary navbar-btn-menu mr-2" id="acm-main-menu-btn" @click="switchMenuState">
      <fa-icon icon="bars"/>
    </a>
    <router-link :to="{ name: 'home' }" @click.native="setMenuState(false)" class="btn btn-success navbar-btn-home mr-2">
      <fa-icon icon="home"/>
    </router-link>
    <a class="navbar-brand text-uppercase" href="#">{{ appName }}</a>
    <small class="version">{{ appVersion }}</small>
    <div class="navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link px-2 py-2 py-lg-1 mr-2 mt-2 mt-lg-1 mb-1 logout-link" href="#" @click="logout">
            <fa-icon icon="power-off"/>
            Logout</a>
        </li>
        <li class="nav-item">
          <a class="nav-link rounded px-2 py-2 py-lg-1 mr-2 mt-2 mt-lg-1 mb-1 account-link" href="#">{{ user.account_type.name }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link rounded px-2 py-2 py-lg-1 mr-2 my-1 user-link" href="#">{{ user.first_name }}</a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import * as pubnub from '@/common/pubnub'
import * as reset from '@/store/reset'

import {
  AUTH_CURRENT_USER
} from '@/store/auth/auth.types'

import {
  NAV_GET_MENU_OPEN,
  NAV_SET_MENU_OPEN
} from '@/store/navigation/nav.types'

export default {
  methods: {
    switchMenuState () {
      if (!this.getMenuState()) {
        setTimeout(() => {
          document.getElementById('nav_quick_find').focus()
        }, 100)
      }
      this.$store.commit(NAV_SET_MENU_OPEN, !this.getMenuState())
    },

    setMenuState (open = true) {
      this.$store.commit(NAV_SET_MENU_OPEN, open)
    },

    getMenuState () {
      return this.$store.getters[NAV_GET_MENU_OPEN]
    },

    logout () {
      pubnub.unsub()
      reset.resetAll()
      this.$router.push({ name: 'home' })
    }
  },

  computed: {
    user () {
      return this.$store.getters[AUTH_CURRENT_USER]
    },

    appName () {
      return process.env.APP_NAME
    },

    appVersion () {
      return process.env.APP_VERSION
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~sass-material-colors/sass/sass-material-colors";

  .navbar-btn-menu {
    color: white !important;
  }

  .navbar-btn-home {
    color: white !important;
  }

  .navbar-bg {
    background-color: material-color('grey', '800');
  }

  .version {
    color: material-color('grey', '500');
    font-size: small;
  }

  .logout-link {
    color: material-color('deep-orange', '400') !important;
    font-size: small;
  }

  .logout-link:hover {
    color: material-color('deep-orange', '500') !important;
  }

  .account-link {
    color: material-color('grey', '50') !important;
    background-color: material-color('grey', '700');
    font-size: small;
  }

  .account-link:hover {
    background-color: material-color('grey', '600');
  }

  .user-link {
    color: white !important;
    background-color: material-color('orange', '900');
    font-size: small;
  }

  .user-link:hover {
    background-color: material-color('orange', '800');
  }

  /*
  .user-link a:visited, .user-link a:hover, .user-link a:active {
    color: green !important;
    background-color: material-color('blue', '700');
    font-size: small;
  }
  */
</style>



// WEBPACK FOOTER //
// src/views/navigation/NavBar.vue